import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon, WrenchIcon, FlameIcon, BathIcon, DropletsIcon, SirenIcon, ShieldCheckIcon, BoxIcon } from "lucide-react";
import { services, featuredService } from "../../data/services";
import { Service } from "../../types/content";
const icons: Record<Service["icon"], BoxIcon> = {
  wrench: WrenchIcon,
  flame: FlameIcon,
  bath: BathIcon,
  droplets: DropletsIcon,
  siren: SirenIcon,
  shield: ShieldCheckIcon
};
export function ServicesSection() {
  return <section id="services" className="w-full bg-paper py-20 md:py-28" data-id="element-147" data-mp="qmr1t9mg7c6w">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-148" data-mp="bqrva3ezlk3v">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-149" data-mp="bq9ssp1qe9ni">
          <h2 className="max-w-xl text-4xl font-semibold leading-[1.05] tracking-tight text-ink md:text-5xl" data-id="element-150" data-mp="go1idcewljoj">
            Tout ce qui fait circuler l'eau et la chaleur chez vous
          </h2>
          <p className="max-w-sm text-base leading-relaxed text-muted" data-id="element-151" data-mp="31gmudbjmrq4m">
            Une seule équipe pour l'installation, la rénovation et l'entretien —
            particuliers comme professionnels.
          </p>
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-152" data-mp="3ve66mth0slzr">
          <article className="flex flex-col overflow-hidden rounded-2xl bg-ink text-white lg:col-span-5" data-id="element-153" data-mp="d79mp66aejg9">
            <img src={featuredService.image} alt="Pompe à chaleur air/eau installée contre un mur de maison" className="h-64 w-full object-cover md:h-72" data-id="element-154" data-mp="85u37ijrckzz" />
            <div className="flex flex-1 flex-col p-7 md:p-8" data-id="element-155" data-mp="i631d1xb8gi0">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-lime text-ink" data-id="element-156" data-mp="i3gul4i8u50u">
                <FlameIcon className="h-5 w-5" aria-hidden="true" data-id="element-157" data-mp="vysnd6cu9lf4" />
              </span>
              <h3 className="mt-5 text-2xl font-semibold tracking-tight" data-id="element-158" data-mp="rxh7vtnoigkn">
                {featuredService.title}
              </h3>
              <p className="mt-3 leading-relaxed text-white/70" data-id="element-159" data-mp="10wb0za1swotg">
                {featuredService.description}
              </p>
              <ul className="mt-6 flex flex-wrap gap-2" data-id="element-160" data-mp="3up28w1gb36jd">
                {featuredService.tags.map(t => <li key={t} className="rounded-full border border-white/20 px-3 py-1 text-sm text-white/80" data-id="element-161" data-mp="2jgn1uu2nu59">
                    {t}
                  </li>)}
              </ul>
              <Link to="/services" className="mt-auto inline-flex items-center gap-2 pt-8 font-medium text-lime hover:underline" data-id="element-162" data-mp="c9rpte20rxak">
                En savoir plus
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-163" data-mp="h8uwt41k8dl6" />
              </Link>
            </div>
          </article>

          <ul className="divide-y divide-ink/10 border-y border-ink/10 lg:col-span-7" data-id="element-164" data-mp="qa2gafzf39v7">
            {services.map(s => {
            const Icon = icons[s.icon];
            return <li key={s.title} data-id="element-165" data-mp="v848bqetmjit">
                  <Link to="/services" className="group flex items-start gap-5 py-6 md:py-7" data-id="element-166" data-mp="2s1fkf2tk9dq7">
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white text-ink transition-colors duration-150 ease-out group-hover:bg-lime" data-id="element-167" data-mp="2x00k914whve4">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-168" data-mp="2pikm70hyd53e" />
                    </span>
                    <div className="flex-1" data-id="element-169" data-mp="2ko7yufdcv9md">
                      <h3 className="text-xl font-semibold tracking-tight text-ink" data-id="element-170" data-mp="2fq6d1mojow77">
                        {s.title}
                      </h3>
                      <p className="mt-1.5 leading-relaxed text-muted" data-id="element-171" data-mp="2aps84di8q2de">
                        {s.description}
                      </p>
                    </div>
                    <ArrowUpRightIcon className="mt-1 h-5 w-5 shrink-0 text-ink/40 transition-[color,transform] duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink" aria-hidden="true" data-id="element-172" data-mp="33hu01tiorn47" />
                  </Link>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}